import { render, staticRenderFns } from "./TrackerItem.vue?vue&type=template&id=48b3e064&scoped=true"
import script from "./TrackerItem.vue?vue&type=script&lang=js"
export * from "./TrackerItem.vue?vue&type=script&lang=js"
import style0 from "./TrackerItem.vue?vue&type=style&index=0&id=48b3e064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b3e064",
  null
  
)

export default component.exports